import React from 'react';
import { Link } from "gatsby"

const HashtagList = ({tags}) => (
  <span className="tags-links hashtag-list">

    <span className="screen-reader-text">Tags: </span>

    {
      tags && tags.nodes.map(tag => (
        <Link key={tag.name} to={`/tag/${tag.slug}`} rel="tag">
          <span style={{fontFamily: "urw-din"}}>#{tag.slug.toUpperCase()}</span>
        </Link>
      ))
      .reduce((accu, elem) => {
        return accu === null ? [elem] : [...accu, "\xa0\xa0\xa0", elem]
      }, null)
    }
  </span>

)

export default HashtagList
